export default __webpack_public_path__ + "static/media/perfil.773f5f1f.jpg";